import { render, staticRenderFns } from "./ParametrosCalculo.vue?vue&type=template&id=9d75c4a2&scoped=true&"
import script from "./ParametrosCalculo.vue?vue&type=script&lang=js&"
export * from "./ParametrosCalculo.vue?vue&type=script&lang=js&"
import style0 from "./ParametrosCalculo.vue?vue&type=style&index=0&id=9d75c4a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d75c4a2",
  null
  
)

export default component.exports